<template>
  <div>
    <v-row class="fill-height">
      <v-col cols="12" md="6">
        <DashboardWidgetTermineAllgemein />
      </v-col>
      <v-col cols="12" md="6">
        <DashboardWidgetOffeneRechnungen />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DashboardWidgetTermineAllgemein from "@/components/dashboards/widgets/DashboardWidgetTermineAllgemein.vue";
import DashboardWidgetOffeneRechnungen from "@/components/dashboards/widgets/DashboardWidgeOffeneRechnungen.vue";

export default {
  name: "DashboardRechnungswesen",
  components: {
    DashboardWidgetOffeneRechnungen,
    DashboardWidgetTermineAllgemein,
  },
};
</script>

<style scoped></style>
